"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ForgotPass;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _firebase = require("../firebase");

var _auth = require("firebase/auth");

var _LoginSignup = require("./LoginSignup");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ForgotPass(props) {
  var setAction = props.setAction;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submitted = _useState4[0],
      setSubmitted = _useState4[1];

  var sendEmail = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var email;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              email = emailRef.current.value;

              if ((0, _LoginSignup.validEmail)(email)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", setErrorMessage("Please enter a valid email."));

            case 4:
              (0, _auth.sendPasswordResetEmail)(_firebase.auth, email).then(function () {
                // User has been sent a password reset email with a link to do the reset.
                setSubmitted(true);
                setErrorMessage("");
              }).catch(function (errorMsg) {
                // Error occurred trying to reset email.
                setErrorMessage(errorMsg);
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendEmail(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var emailRef = (0, _react.useRef)();
  var title = !submitted ? 'Forgot your password?' : 'Password reset email sent.';
  var message = !submitted ? 'Enter your email to recieve instructions on how to reset your password.' : 'You should receive a password reset email within the next five minutes. Follow the instructions inside to reset your password, then try logging in with your new password. If you don’t receive an email in the next five minutes, try clicking "Resend Email."';
  var buttons = !submitted ? /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "btn btn-round btn-primary m-1 w-100",
    id: "submitAuth"
  }, "Submit") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "btn btn-round btn-secondary m-1 w-100"
  }, "Resend Email"), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setAction('signin');
    },
    className: "btn btn-round btn-primary m-1 w-100"
  }, "Return to Sign in"));
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: sendEmail,
    style: {
      width: "80%",
      maxWidth: "20rem",
      margin: "1rem auto"
    }
  }, /*#__PURE__*/_react.default.createElement("h2", null, title), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      fontSize: '.9rem'
    }
  }, message), /*#__PURE__*/_react.default.createElement("p", {
    style: submitted ? {
      height: 0,
      margin: 0
    } : {}
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "email",
    style: {
      visibility: !submitted ? 'visible' : 'hidden'
    },
    className: "form-control mb-2",
    name: "email",
    ref: emailRef,
    placeholder: "Email"
  })), buttons, /*#__PURE__*/_react.default.createElement("div", {
    id: "info-message",
    style: {
      color: '#d10909'
    },
    className: "p-1 text"
  }, errorMessage));
}